// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/usage.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetActiveEnvironmentsCountRequest, GetActiveEnvironmentsCountResponse, GetActiveEnvironmentsTimeSeriesRequest, GetActiveEnvironmentsTimeSeriesResponse, GetActiveUsersCountRequest, GetActiveUsersCountResponse, GetActiveUsersTimeSeriesRequest, GetActiveUsersTimeSeriesResponse, GetAdoptionUsageSummaryRequest, GetAdoptionUsageSummaryResponse, GetEnvironmentRuntimeRequest, GetEnvironmentRuntimeResponse, GetEnvironmentRuntimeTimeSeriesRequest, GetEnvironmentRuntimeTimeSeriesResponse, GetEnvironmentSessionsTimeSeriesRequest, GetEnvironmentSessionsTimeSeriesResponse, GetTopActiveUsersRequest, GetTopActiveUsersResponse, GetTopEnvironmentClassesRequest, GetTopEnvironmentClassesResponse, GetTopProjectsRequest, GetTopProjectsResponse, ListEnvironmentUsageRecordsRequest, ListEnvironmentUsageRecordsResponse } from "./usage_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * UsageService provides usage information about environments, users, and projects.
 *
 * @generated from service gitpod.v1.UsageService
 */
export const UsageService = {
  typeName: "gitpod.v1.UsageService",
  methods: {
    /**
     * Gets the count of active users.
     *
     * Returns the count of unique users who were active within the specified date range.
     *
     * @generated from rpc gitpod.v1.UsageService.GetActiveUsersCount
     */
    getActiveUsersCount: {
      name: "GetActiveUsersCount",
      I: GetActiveUsersCountRequest,
      O: GetActiveUsersCountResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the top active users based on total runtime.
     *
     * Returns a list of users sorted by their total environment runtime within the specified date range.
     * Each result includes the user ID, name (if available), and their total environment runtime in seconds.
     *
     * @generated from rpc gitpod.v1.UsageService.GetTopActiveUsers
     */
    getTopActiveUsers: {
      name: "GetTopActiveUsers",
      I: GetTopActiveUsersRequest,
      O: GetTopActiveUsersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets active users time series in the specified date range, aggregated by the specified resolution.
     *
     * Returns a time series of active user counts within the specified date range, aggregated by the specified resolution.
     * Each data point includes the timestamp and the count of unique users who were active at that time.
     *
     * @generated from rpc gitpod.v1.UsageService.GetActiveUsersTimeSeries
     */
    getActiveUsersTimeSeries: {
      name: "GetActiveUsersTimeSeries",
      I: GetActiveUsersTimeSeriesRequest,
      O: GetActiveUsersTimeSeriesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists completed environment runtime records within a specified date range.
     *
     * Returns a list of environment runtime records that were completed within the specified date range. Records of currently running environments are not included.
     *
     * Use this method to:
     * - View environment runtime records
     * - Filter by project
     * - Create custom usage reports
     *
     * ### Example
     *
     * ```yaml
     * filter:
     *   projectId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   dateRange:
     *     startTime: "2024-01-01T00:00:00Z"
     *     endTime: "2024-01-02T00:00:00Z"
     * pagination:
     *   pageSize: 100
     * ```
     *
     * @generated from rpc gitpod.v1.UsageService.ListEnvironmentUsageRecords
     */
    listEnvironmentUsageRecords: {
      name: "ListEnvironmentUsageRecords",
      I: ListEnvironmentUsageRecordsRequest,
      O: ListEnvironmentUsageRecordsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the count of active environments in the specified date range.
     *
     * @generated from rpc gitpod.v1.UsageService.GetActiveEnvironmentsCount
     */
    getActiveEnvironmentsCount: {
      name: "GetActiveEnvironmentsCount",
      I: GetActiveEnvironmentsCountRequest,
      O: GetActiveEnvironmentsCountResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the active environments time series in the specified date range, aggregated by the specified resolution.
     *
     * @generated from rpc gitpod.v1.UsageService.GetActiveEnvironmentsTimeSeries
     */
    getActiveEnvironmentsTimeSeries: {
      name: "GetActiveEnvironmentsTimeSeries",
      I: GetActiveEnvironmentsTimeSeriesRequest,
      O: GetActiveEnvironmentsTimeSeriesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the total runtime of all environments in the specified date range.
     *
     * @generated from rpc gitpod.v1.UsageService.GetEnvironmentRuntime
     */
    getEnvironmentRuntime: {
      name: "GetEnvironmentRuntime",
      I: GetEnvironmentRuntimeRequest,
      O: GetEnvironmentRuntimeResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the total runtime time series in the specified date range, aggregated by the specified resolution.
     *
     * @generated from rpc gitpod.v1.UsageService.GetEnvironmentRuntimeTimeSeries
     */
    getEnvironmentRuntimeTimeSeries: {
      name: "GetEnvironmentRuntimeTimeSeries",
      I: GetEnvironmentRuntimeTimeSeriesRequest,
      O: GetEnvironmentRuntimeTimeSeriesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the top projects by total environment runtime in the specified date range.
     *
     * @generated from rpc gitpod.v1.UsageService.GetTopProjects
     */
    getTopProjects: {
      name: "GetTopProjects",
      I: GetTopProjectsRequest,
      O: GetTopProjectsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the top environment classes by total runtime in the specified date range.
     *
     * @generated from rpc gitpod.v1.UsageService.GetTopEnvironmentClasses
     */
    getTopEnvironmentClasses: {
      name: "GetTopEnvironmentClasses",
      I: GetTopEnvironmentClassesRequest,
      O: GetTopEnvironmentClassesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets a summary of adoption and usage metrics for the insight card.
     *
     * Returns all scalar values, trends, and a sparkline for the Adoption & Usage
     * insight category. Designed for the Project Home page card and similar summary
     * views. For full-resolution time series, use the individual time series RPCs.
     *
     * @generated from rpc gitpod.v1.UsageService.GetAdoptionUsageSummary
     */
    getAdoptionUsageSummary: {
      name: "GetAdoptionUsageSummary",
      I: GetAdoptionUsageSummaryRequest,
      O: GetAdoptionUsageSummaryResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the environment sessions time series in the specified date range, aggregated by the specified resolution.
     *
     * Environment sessions count total environment starts (environment.started events),
     * as opposed to GetActiveEnvironmentsTimeSeries which counts distinct environment IDs.
     *
     * @generated from rpc gitpod.v1.UsageService.GetEnvironmentSessionsTimeSeries
     */
    getEnvironmentSessionsTimeSeries: {
      name: "GetEnvironmentSessionsTimeSeries",
      I: GetEnvironmentSessionsTimeSeriesRequest,
      O: GetEnvironmentSessionsTimeSeriesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

